import { OurTeam } from './../model/ourteam.model';
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ConfigAssetLoaderService,
  InterceptorSkipHeader,
} from '@icullen/api/shared';
import { withCache } from '@ngneat/cashew';

@Injectable({
  providedIn: 'root',
})
export class OurTeamApiService {
  OURTEAM_API_BASE_URL: string;

  constructor(
    private httpClient: HttpClient,
    //@Inject('apiBaseUrl') private apiBaseUrl: string,
    private configService: ConfigAssetLoaderService
  ) {
    this.OURTEAM_API_BASE_URL =
      configService.getConfig().apiBaseUrl + 'site/ourteam/';
  }

  getAnalystInfo(email: string): Observable<OurTeam> {
    if (email) {
      email = email.split('@')[0].toLowerCase();
    }
    return this.httpClient.get<OurTeam>(
      this.OURTEAM_API_BASE_URL + 'analyst?email=' + email,
      { ...InterceptorSkipHeader, context: withCache() }
    );
  }
}
